import styled from '@emotion/styled'
import { ColorPicker } from '@mantine/core'

const StyledColorPickerContainer = styled.div`
  background: var(--ow-color-white-100);
  border-radius: 4px;
  position: absolute;
  top: 28px;
  left: 0;
  z-index: 1;
  box-shadow: 0 8px 10px -5px rgba(0, 0, 0, 0.08),
    0 16px 24px 2px rgba(0, 0, 0, 0.04), 0 6px 30px 5px rgba(0, 0, 0, 0.05);
  .color-header {
    padding: 16px;
    border-bottom: 1px solid #e7e7e7;
    span {
      font-weight: 500;
      font-size: 16px;
      color: rgba(0, 0, 0, 0.9);
    }
  }
`
const StyledColorPicker = styled(ColorPicker)`
  padding: 16px;
`
export { StyledColorPickerContainer, StyledColorPicker }
